<template>
  <b-alert show variant="danger" v-show="hasErrors">
    <b-form-invalid-feedback :force-show="hasErrors">
      <div v-for="(error, index) in activeErrorMessages" :key="index">
        <div>{{ error }}</div>
      </div>
    </b-form-invalid-feedback>
  </b-alert>
</template>
<script>
import { multiErrorExtractorMixin } from 'vuelidate-error-extractor';
export default {
  name: 'FormSummary',
  extends: multiErrorExtractorMixin,
};
</script>
